import "./css/erisvisionservices.sass"
import "bootstrap-icons/font/bootstrap-icons.scss"
import "bootstrap/dist/js/bootstrap.bundle"

document.addEventListener("DOMContentLoaded", (_) => {
    const html = document.querySelector("html");
    const navbar = document.querySelector("nav.navbar")
    document.addEventListener("scroll", (_) => {
        console.log(html.scrollTop)
        if (html.scrollTop <= 0) {
            navbar.classList.remove("scroll")
            navbar.classList.add("noscroll")
        } else {
            navbar.classList.remove("noscroll")
            navbar.classList.add("scroll")
        }
    })
})